import React, { createContext, useState, useContext } from 'react';

export const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
    const [modalState, setModalState] = useState({
        show: false,
        title: "",
        bodyContent: "",
        bodyContent1: "",
        footer: null,
        size: "lg",
        centered: true,
        className: "",
        backdrop: "static",
    });

    const showModal = (config) => {
        setModalState({
            ...modalState,
            ...config,
            show: true,
        });
    };

    const hideModal = () => {
        setModalState({ ...modalState, show: false });
    };

    return (
        <ModalContext.Provider value={{ modalState, showModal, hideModal }}>
            {children}
        </ModalContext.Provider>
    );
};

export const useModal = () => {
    return useContext(ModalContext);
};